module.exports = __webpack_public_path__ + "img/1-4.d23e19b6.png";